import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { ChangeEventHandler, FC } from 'react';

import { TextFieldStyled } from '../../pages/AdminPanel/components/EditForms';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    display: 'grid',
  },
  formatedDateText: {
    position: 'absolute',
    display: 'inline-block',
    left: '14px',
    top: '13px',
    width: '120px',
    height: '28px',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
  },
}));

interface IDateInputProps {
  id: string;
  name: string;
  label: string;
  helperText: string;
  error: boolean | undefined;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value: string;
}

export const DateInput: FC<IDateInputProps> = ({
  id,
  name,
  label,
  helperText,
  error,
  onChange,
  value,
}) => {
  const classes = useStyles();

  const formatDate = () => {
    if (value === 'Invalid date') return 'mm/dd/yyyy';

    return moment(value).format('MMM Do, YYYY');
  };

  return (
    <div className={classes.container}>
      <TextFieldStyled
        id={id}
        name={name}
        label={label}
        type="date"
        helperText={helperText}
        error={error}
        onChange={onChange}
        variant="outlined"
      />
      <Typography className={classes.formatedDateText}>
        {formatDate()}
      </Typography>
    </div>
  );
};
